export default function ErrorToastIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
<svg
			width="60"
			height="61"
			viewBox="0 0 60 61"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="30.0517"
				cy="30.145"
				r="27.7041"
				fill="#FF6571"
				fill-opacity="0.16"
			/>
			<circle
				cx="30.0518"
				cy="30.145"
				r="22.0693"
				fill="#FF6571"
				fill-opacity="0.2"
			/>
			<circle cx="30.0515" cy="30.145" r="14.5564" fill="#FF6571" />
			<path
				d="M29.0959 30.3948L30.9043 30.3948L30.9043 23.2146L29.0959 23.2146L29.0959 30.3948Z"
				fill="#FBFBFB"
			/>
			<path
				d="M30.0001 32.8056C29.5007 32.8056 29.0959 33.2104 29.0959 33.7098C29.0959 34.2092 29.5007 34.614 30.0001 34.614C30.4995 34.614 30.9043 34.2092 30.9043 33.7098C30.9043 33.2104 30.4995 32.8056 30.0001 32.8056Z"
				fill="#FBFBFB"
			/>
		</svg>
	);
}
